import { defineComponent, ref, computed, watch, nextTick } from 'vue';
import { default as PfSelect, selectProps } from '../select';
import { withInstall } from '../_util/type';
import useConfigInject from '../_util/hooks/useConfigInject';
import { initDefaultProps } from '../_util/props-util';
import InfoTwoTone from '@pf-ui/pf-icons-vue/InfoTwoTone';
import classNames from '../_util/classNames';
function toggleArrayItem(arr, row, key) {
    const index = arr.findIndex((item) => item[key] === row[key]);
    if (index !== -1) {
        return [...arr.slice(0, index), ...arr.slice(index + 1)];
    }
    return [...arr, row];
}
export const selectTableProps = () => ({
    value: [Array, Object, String, Number],
    ...selectProps,
    mode: String,
    tableDrop: Array,
    valueKey: String,
    labelKey: String,
    showSearch: Boolean,
    options: Array,
});
const SelectTable = defineComponent({
    name: 'PfSelectTable',
    inheritAttrs: false,
    props: initDefaultProps(selectTableProps(), {
        valueKey: 'id',
        labelKey: 'name',
        showSearch: false,
    }),
    emits: ['change', 'search', 'update:value'],
    setup(props, { attrs, emit }) {
        const { prefixCls } = useConfigInject('select-table', props);
        const isMultiple = computed(() => {
            return props?.mode === 'multiple' || props?.mode === 'tags';
        });
        const value = ref(isMultiple.value
            ? [
                ...(props.options && props.options.length > 0
                    ? props.options.filter(x => Array.isArray(props?.value) ? props?.value?.includes(x[props.valueKey]) : false)
                    : Array.isArray(props?.value)
                        ? props?.value?.map((x) => ({ [props.valueKey]: x, [props.labelKey]: x }))
                        : []),
            ]
            : props.options && props.options.length > 0
                ? props.options.find(x => x[props.valueKey] === props?.value)
                : { [props.valueKey]: props?.value, [props.labelKey]: props?.value });
        const searchValue = ref('');
        watch(() => props.value, v => {
            if (v === null || v === undefined) {
                value.value = isMultiple.value ? [] : undefined;
                return;
            }
            if (isMultiple.value) {
                let valueArr = [...value.value].map((x) => x[props.valueKey]);
                if (Array.isArray(v) && valueArr.join() !== v.join()) {
                    let newArr = [...v]?.filter((x) => !valueArr.includes(x));
                    let arr = props.options.filter(x => newArr?.includes(x[props.valueKey]));
                    let arrKey = arr.map((x) => x[props.valueKey]);
                    // 无下拉options, 也要显示value
                    newArr.forEach((x) => {
                        if (!arrKey.includes(x)) {
                            arr.push({ [props.valueKey]: x, [props.labelKey]: x });
                        }
                    });
                    let delArr = valueArr.filter((x) => !v.includes(x));
                    value.value = [
                        [...value.value].filter((x) => !delArr.includes(x[props.valueKey])),
                        ...arr,
                    ];
                }
            }
            else {
                if (v !== value.value?.[props?.valueKey]) {
                    let obj = props.options.find(x => x[props.valueKey] === v);
                    value.value = { ...obj };
                }
            }
        });
        const open = ref(false);
        const handleSelectRowClick = (e, row) => {
            if (isMultiple.value) {
                let toggleArr = toggleArrayItem([...(value.value || [])], row, props.valueKey);
                open.value = true;
                value.value = [...toggleArr];
                let valueArr = [...toggleArr].map((x) => x[props.valueKey]);
                emit?.(`update:value`, valueArr);
                emit('change', [...toggleArr]);
            }
            else {
                open.value = false;
                value.value = { ...row };
                emit('update:value', row[props.valueKey]);
                emit('change', { ...row });
            }
            nextTick(() => {
                searchValue.value = '';
            });
            e.preventDefault();
        };
        const handleMouseDouwn = (e) => e.preventDefault();
        const elSelectSlots = {
            $stable: true,
            dropdownRender: () => props?.tableDrop?.length ? (<div>
            {props.options.length > 0 ? (<div>
                <div class={`${prefixCls.value}-drop-header`}>
                  {props?.tableDrop.map((item) => (<div style={{ minWidth: `${item.width || 120}px` }} class={`${prefixCls.value}-drop-header-item`}>
                      {item.title}
                    </div>))}
                </div>
                <div class={`${prefixCls.value}-drop`}>
                  {props.options?.map((item, index) => (<div class={classNames(`${prefixCls.value}-drop-item`, {
                            [`${prefixCls.value}-drop-item-striped`]: index % 2 === 0,
                            [`${prefixCls.value}-drop-item-selected`]: isMultiple.value
                                ? value.value?.find((x) => x[props.valueKey] === item[props.valueKey])
                                : value.value?.[props.valueKey] === item[props.valueKey],
                        })} onClick={(e) => handleSelectRowClick(e, item)} onMousedown={handleMouseDouwn} key={item[props.valueKey] + '-' + index}>
                      {props.tableDrop.map((drop) => (<div class={classNames(`${prefixCls.value}-drop-label`, {})} style={{ minWidth: `${drop.width || 120}px` }} title={item[drop.label]}>
                          {drop.render ? drop.render(item) : item[drop.label]}
                        </div>))}
                    </div>))}
                  {props.options.length >= 50 ? (<div class={classNames(`${prefixCls.value}-drop-footer`)}>
                      只显示前50条结果，请完善搜索关键字{' '}
                    </div>) : ('')}
                </div>
              </div>) : null}
            {props?.options.length === 0 ? (<div class={classNames(`${prefixCls.value}-drop-empty`)}>
                <InfoTwoTone class={classNames(`${prefixCls.value}-drop-empty-icon`)}/>
                暂无数据
              </div>) : null}
          </div>) : (''),
        };
        const handleChange = (_value) => {
            if (!_value) {
                value.value = undefined;
                emit('change', undefined);
            }
        };
        const handleDeselect = (v) => {
            if (!isMultiple.value) {
                emit?.(`update:value`, undefined);
                return;
            }
            // 此处的v是labelkey, 对应显示的值 (有相同label 会有问题)
            if (v) {
                let toggleArr = [...value.value].filter((x) => x[props.labelKey] !== v);
                value.value = [...toggleArr];
                emit('change', [...toggleArr]);
                emit?.(`update:value`, [...toggleArr].map((x) => x[props.valueKey]));
            }
        };
        const _handleDropdownVisibleChange = (_open) => {
            open.value = _open;
            if (!_open) {
                searchValue.value = '';
                emit('search', undefined);
            }
        };
        const otherProps = {};
        if (props.showSearch) {
            otherProps.onSearch = (value) => {
                searchValue.value = value;
                emit('search', value);
            };
        }
        return () => (<>
        <PfSelect placeholder="请选择" {...attrs} mode={props.mode} open={open.value} filterOption={false} searchValue={searchValue.value} showSearch={props.showSearch || false} {...otherProps} onDropdownVisibleChange={_handleDropdownVisibleChange} defaultActiveFirstOption={false} onChange={handleChange} onDeselect={handleDeselect} v-slots={elSelectSlots} value={isMultiple.value
                ? value.value?.map((x) => x[props.labelKey])
                : value.value?.[props.labelKey]}/>
      </>);
    },
});
export default withInstall(SelectTable);
